import { ContentRow as ContentRowBase } from '@aibees/shared/features/advance-table/components/advanced-table-select-popup/styles';
import { ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(ListItem)``;

export const ContentRow = styled(ContentRowBase)``;
